<SidebarShell :logo="short_logo" :brand_title="brand_name" :brand_subtitle="brand_subtitle" :initials="initials"
  :full_name="full_name">
  <!-- ✅ FORWARD SIDEBAR HEADER ACTIONS (X BUTTON) -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="px-3 mt-3">
      <!-- ✅ MENU LIST -->
      <template v-for="item in menuItems" :key="item.key">

        <!-- ✅ SECTION HEADER (Previously Accordion) -->
        <div v-if="item.type === 'section' || item.type === 'accordion'" class="mt-2">

          <!-- section header -->
          <div class="d-flex align-items-center justify-content-between gap-2 sidebar-section-header"
            :class="{ active: is_section_active(item) }" style="cursor:default;">
            <div class="d-flex align-items-center gap-2">
              <i :class="item.icon"></i>

              <span v-if="!$root.sidebar_collapsed" class="sidebar-menu-text">
                {{ item.label }}
              </span>
            </div>
          </div>

          <!-- section body (always visible if not collapsed) -->
          <div v-show="!$root.sidebar_collapsed" class="ps-2 mt-2">
            <div v-for="child in item.children" :key="child.key"
              class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
              :class="{ active: active_menu_item === child.key, 'disabled-tile': is_menu_item_disabled(child) }"
              :role="is_menu_item_disabled(child) ? null : 'button'"
              :style="{ cursor: is_menu_item_disabled(child) ? 'not-allowed' : 'pointer' }"
              @click.stop="select_menu_item(child)">
              <i :class="child.icon"></i>
              <span class="text-xs sidebar-menu-text">{{ child.label }}</span>
            </div>
          </div>

        </div>

        <!-- ✅ NORMAL MENU ITEM -->
        <div v-else class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
          :class="{ active: active_menu_item === item.key, 'disabled-tile': is_menu_item_disabled(item) }"
          :style="{ cursor: is_menu_item_disabled(item) ? 'not-allowed' : 'pointer' }"
          @click="select_menu_item(item)">
          <i :class="item.icon"></i>

          <!-- ✅ label only when NOT collapsed -->
          <span v-if="!$root.sidebar_collapsed" class="text-xs sidebar-menu-text">
            {{ item.label }}
          </span>
        </div>

      </template>
    </div>
  </template>

  <template #footer-actions>
    <ProbaRedirectButton />
  </template>
</SidebarShell>
